import { IconButton } from "@mui/material";
import classNames from "classnames";
import { ClipboardIcon } from "../../../../../../shared/icons/ClipboardIcon";
import styles from "../styles.module.css";

interface Props {
  onClick: () => void;
  isDisabled: boolean;
}

export const LinkClipboard: React.FC<Props> = ({ onClick, isDisabled }) => {
  return (
    <IconButton
      className={styles["action-button"]}
      onClick={onClick}
      disabled={isDisabled}
    >
      <ClipboardIcon
        className={classNames({
          [styles["disabled"]]: isDisabled,
        })}
      />
    </IconButton>
  );
};
